<template>
  <v-form>
    <v-card flat class="fill-height">
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <provider-title title="Ficha de Atención"></provider-title>
          </v-flex>

          <v-flex xs12 md8 xl7 class="mt-3" v-if="isOwnerOrAdmin">
            <provider-sub-title text="Reabrir Citas"></provider-sub-title>
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-switch
                    label="Permitir reabrir citas"
                    v-model="canReOpenAttention"
                ></v-switch>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                    :disabled="!canReOpenAttention"
                    :items="maxHoursReopenOptions"
                    label="Max. tiempo transcurrido después de cerrada"
                    v-model="maxHoursReopenAttention"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <template v-if="userIsSpecialist">
            <v-flex xs12 md8 xl7 class="mt-3">
              <provider-sub-title text="Plantilla"></provider-sub-title>
              <small>¿Qué diseño de ficha quieres utilizar para tus citas?</small>
              <attention-template-picker auto-save/>
            </v-flex>

            <template v-if="needsExamConfig">
              <v-flex xs12 class="mt-3">
                <provider-sub-title text="Exámenes"></provider-sub-title>
                <v-alert type="info" color="grey lighten-3" :value="true" border="left">
                  <small class="black--text">Selecciona los exámenes que deseas tener disponible en tus fichas</small>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn @click="cantFindExamDialog = true" color="primary" depressed v-on="on" fab small class="pa-0" style="width:25px; height:25px">
                        <v-icon size="12">fas fa-question</v-icon>
                      </v-btn>
                    </template>
                    <span>¿No encuentras un exámen?</span>
                  </v-tooltip>
                </v-alert>
              </v-flex>

              <v-flex xs12>
                <v-progress-linear indeterminate v-if="loading" height="2" color="primary"></v-progress-linear>
                <v-slide-y-transition v-else>
                  <template v-show="!loading">
                    <span class="caption" v-if="availablePhysicalExams.length === 0">No se han encontrado exámenes</span>
                    <physical-exams-tree
                        v-else
                        :exams="availablePhysicalExams"
                        :selected="exams"
                        @change="onExamsChange"
                    />
                  </template>
                </v-slide-y-transition>
              </v-flex>
            </template>
          </template>

        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="saveSettings"
            :loading="saving"
        >guardar</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog max-width="500" v-model="cantFindExamDialog">
      <v-card>
        <v-card-text>
          Aquí solo se muestran los exámenes correspondientes a las especialidades configuradas. Si no encuentras un exámen o una especialidad <span v-html="servicesMessage"></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="primary" small @click="cantFindExamDialog = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>

import { ApiUtils } from '@/utils/ApiUtils'
import {mapState, mapActions} from 'vuex'
import {debounce} from "@/utils/Common";
import {needsExamConfig} from "@/utils/Specialist";
import ProviderTitle from "@/components/providers/panel/ProviderTitle";
import ProviderSubTitle from "@/components/providers/panel/ProviderSubTitle";
import PhysicalExamsTree from "@/components/appointments/attention/physical_exams/PhysicalExamsTree";
import AttentionTemplatePicker from "@/components/providers/settings/AttentionTemplatePicker";

export default {
  components: {AttentionTemplatePicker, PhysicalExamsTree, ProviderSubTitle, ProviderTitle},
  props: {
    submitFn: {
      type: Function
    }
  },
  data() {
    return {

      saving: false,
      attention_template: '',

      canReOpenAttention: false,
      maxHoursReopenAttention: 3,

      cantFindExamDialog: false,
      exams: [],
      changedExams: [],

      loadingProviderExams: false,
      requiredRules: [v => !!v || 'Campo Requerido']

    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    ...mapState(['loadingPhysicalExams', 'availablePhysicalExams', 'currentProvider']),
    needsExamConfig,
    maxHoursReopenOptions(){
      return [
        {
          value: 3,
          text: '3 horas'
        },
        {
          value: 24,
          text: '1 día'
        },
        {
          value: 72,
          text: '3 días'
        },
        {
          value: 168,
          text: '1 semana'
        },
        {
          value: 720,
          text: '1 mes'
        },
        {
          value: 8760,
          text: '1 año'
        },
      ]
    },
    servicesMessage(){
      const vm = this
      if(vm.isOwnerOrAdmin){
        return `puedes agregar o quitar especialidades asociadas a tu ${vm.isInstitution ? 'centro/institución' : 'cuenta'} desde la sección <a href="/panel/provider/services">Servicios</a>.`
      }

      return 'pídele al administrador de la cuenta que la asocie desde la configuración de servicios.'

    },
    loading(){
      const vm = this
      return vm.loadingProviderExams || vm.loadingPhysicalExams
    }
  },
  methods: {
    ...mapActions(['fetchPhysicalExams']),
    onExamsChange(exams){
      const vm = this
      vm.changedExams = exams.map(exam => exam.id)
    },
    async saveSettings(){
      const vm = this
      if(vm.saving || !vm.currentProvider) return
      vm.saving = true
      await vm.syncExams()

      if(vm.isOwnerOrAdmin){
        const payload = {
          can_reopen_attention: vm.canReOpenAttention ? 1 : 0,
          max_hours_reopen_attention: vm.maxHoursReopenAttention
        }
        const response = await ApiUtils.makePatch(`provider/${vm.currentProvider.id}/settings`, null, payload)
        if(!response.ok){
          vm.toast('Ha ocurrido un error guardando la configuración', 'error')
        }else{
          vm.toast('Configuración guardada correctamente')
        }
      }
      vm.saving = false
      await ApiUtils.fetchMe()
    },
    async syncExams() {

      const vm = this
      if(!vm.currentProvider || vm.globalLoading) return true
      const exams = vm.changedExams
      const { id } = vm.currentProvider
      const payload = {
        physical_exams: exams
      }
      vm.setGlobalLoading(true)
      const response = await ApiUtils.makePost(
          `providers/${id}/exams/physical/sync`,
          payload
      )
      vm.setGlobalLoading(false)

    },
    async loadData() {
      const vm = this

      await vm.fetchPhysicalExams(vm.currentProvider.id)

      if(!vm.currentProvider || vm.loadingProviderExams) return
      const { id, settings } = vm.currentProvider

      const {
        can_reopen_attention,
        max_hours_reopen_attention
      } = settings

      vm.canReOpenAttention = can_reopen_attention
      vm.maxHoursReopenAttention = max_hours_reopen_attention || 3

      const response = await ApiUtils.makeGet(`providers/${id}/exams/physical/synced`)
      const json = await response.json()

      if(!response.ok){
        return vm.toast(json.message, 'error')
      }

      vm.exams = json.result.physical_exams

    }
  },
  watch:{
    changedExams(){}
  }
}
</script>
